/**
 * Settings Module Types
 */

/** Язык интерфейса */
export enum Language {
  RU = 'ru',
  EN = 'en',
  VN = 'vn'
}

/** Тема интерфейса */
export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
  AUTO = 'auto'
}

/** Настройки уведомлений */
export interface NotificationSettings {
  emailNotifications: boolean
  pushNotifications: boolean
  dealUpdates: boolean
  clientUpdates: boolean
  systemUpdates: boolean
}

/** Настройки отображения */
export interface DisplaySettings {
  language: Language
  theme: Theme
  itemsPerPage: number
  showHints: boolean
  /**
   * Просмотренные онбординги по featureId, напр. { 'routing-rules': true }.
   * Переиспользуемый механизм первого входа (useFeatureOnboarding).
   */
  onboardingSeen?: Record<string, boolean>
}

/** Настройки пользователя */
export interface UserSettings {
  notifications: NotificationSettings
  display: DisplaySettings
}

/** Профиль пользователя (для редактирования) */
export interface UserProfile {
  name: string
  email: string
  phone?: string
  position?: string
  avatar?: string
}
